/***
*
*   LOADER
*   Infinite spinning animation for loading states
*
**********/

import TopGrep from './images/logoOrbit.svg';
import genericLoader from './images/genericLoader.svg';
import { ClassHelper, AuthContext } from 'components/lib';
import Style from './loader.module.scss';

import { useContext } from 'react';

export function Loader(props) {

  const loaderStyle = ClassHelper(Style, props);
  const authContext = useContext(AuthContext);
  const loadingIcon = authContext?.user?.accounts[0]?.whitelabel ? genericLoader : TopGrep

  return (
    <div className={loaderStyle}>
      <img src={loadingIcon} className={Style.orbit} alt='Orbit Spinner' />
    </div>
  );
}